import { all, fork } from "redux-saga/effects";
import { saga as authSaga } from "@containers/Auth/store";
import projectSaga from "@containers/Project/store/saga";
import userSaga from "@containers/User/store/saga";
import sharedSaga from "@shared/store/saga";
import procedureSaga from "@containers/Procedure/store/saga";
import surveySagas from "@containers/Survey/store/saga";
import goalsSagas from "@containers/Goal/store/saga";
import recognitionsSagas from "@containers/Recognition/store/saga";
import sparksSaga from "@containers/Recognition/store/sparks/saga";
import chartSagas from "@containers/AccountabilityChart/store/saga";
import chatSaga from "@containers/Chat/store/saga";
import evaluationSaga from "@containers/Evaluation/store/saga";
import procedureIndexSaga from "@containers/ProcedureIndex/store/saga";
import settingsSaga from "@containers/Settings/store/saga";
import auditLogSaga from "@containers/AuditLog/store/saga";

const allSagas = [
  authSaga,
  projectSaga,
  procedureSaga,
  surveySagas,
  goalsSagas,
  sharedSaga,
  userSaga,
  recognitionsSagas,
  sparksSaga,
  chartSagas,
  chatSaga,
  evaluationSaga,
  procedureIndexSaga,
  settingsSaga,
  auditLogSaga,
];

export default function* appSagas() {
  yield all(allSagas.map(fork));
}
